import React, { useContext, useEffect, useState } from 'react';
import { MoonIcon, SunIcon } from '@heroicons/react/24/outline';
import { AuthContext } from '../utils/auth.js';
import { isAdminEmail } from '../utils/adminUsers.js';
import {
  DEV_DARK_MODE_EVENT,
  isDevDarkModeEnabled,
  toggleDevDarkMode,
} from '../utils/devDarkMode.js';

const defaultClassName =
  'inline-flex h-8 items-center gap-1.5 rounded-full bg-gray-100 px-3 text-xs font-semibold leading-none text-gray-700 ring-1 ring-gray-200 hover:bg-gray-50';

export default function DevDarkModeToggle({ className = defaultClassName }) {
  const { currentUser } = useContext(AuthContext);
  const [enabled, setEnabled] = useState(() => isDevDarkModeEnabled());

  useEffect(() => {
    const sync = () => setEnabled(isDevDarkModeEnabled());
    sync();
    window.addEventListener(DEV_DARK_MODE_EVENT, sync);
    return () => window.removeEventListener(DEV_DARK_MODE_EVENT, sync);
  }, [currentUser?.email]);

  if (!isAdminEmail(currentUser?.email)) {
    return null;
  }

  const handleToggle = () => {
    setEnabled(toggleDevDarkMode(currentUser.email));
  };

  return (
    <button
      type="button"
      onClick={handleToggle}
      title={enabled ? 'Switch to light mode' : 'Switch to dark mode'}
      aria-label={enabled ? 'Switch to light mode' : 'Switch to dark mode'}
      className={className}
    >
      {enabled ? (
        <>
          <SunIcon className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />
          Light
        </>
      ) : (
        <>
          <MoonIcon className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />
          Dark
        </>
      )}
    </button>
  );
}
